export const IS_BRAND_PULSZ = process.env.BRAND_NAME === 'pulsz'
export const IS_BRAND_PULSZBINGO = process.env.BRAND_NAME === 'pulszbingo'
